var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPlanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1456",
    "data-name": "Raggruppa 1456",
    transform: "translate(-683 -310)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_889",
    "data-name": "Rettangolo 889",
    transform: "translate(683 310)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1456-2",
    "data-name": "Raggruppa 1456"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_890",
    "data-name": "Rettangolo 890",
    width: 8,
    height: 3,
    transform: "translate(685 321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_891",
    "data-name": "Rettangolo 891",
    width: 11,
    height: 3,
    transform: "translate(685 317)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_892",
    "data-name": "Rettangolo 892",
    width: 4,
    height: 3,
    transform: "translate(685 312)",
    fill: "#fff"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlanner);
export default __webpack_public_path__ + "static/media/icon_planner.8619a058c52f33f1cd2ea9adad3d12ac.svg";
export { ForwardRef as ReactComponent };